/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Image, StyleSheet, Text, View, type StyleProp, type ViewStyle } from 'react-native';
import { VUELTO_V_MARK } from '../../../bootSplashAssets';
import { colors } from '../../shared/theme/colors'
import { spacing } from '../../shared/theme/spacing';

type AppLogoMarkProps = {
  /** Lado del icono (px). PNG transparente — sin fondo ni radius que recorte el glow. */
  size?: number;
  /** Muestra la palabra «Vuelto» debajo del icono (pantallas auth). */
  showWordmark?: boolean;
  /** Alineación horizontal del bloque. */
  align?: 'center' | 'flex-start';
  style?: StyleProp<ViewStyle>;
};

export function AppLogoMark({
  size = 56,
  showWordmark = false,
  align = 'center',
  style,
}: AppLogoMarkProps) {
  return (
    <View style={[styles.root, align === 'center' ? styles.alignCenter : styles.alignStart, style]}>
      <Image
        source={VUELTO_V_MARK}
        style={{ width: size, height: size }}
        resizeMode="contain"
        accessibilityIgnoresInvertColors
        accessibilityLabel="Vuelto"
      />
      {showWordmark ? <Text style={styles.wordmark}>Vuelto</Text> : null}
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    gap: spacing.sm,
  },
  alignCenter: {
    alignItems: 'center',
  },
  alignStart: {
    alignItems: 'flex-start',
  },
  wordmark: {
    fontSize: 11,
    fontWeight: '700',
    letterSpacing: 6,
    textTransform: 'uppercase',
    color: colors.accent,
    paddingLeft: 6,
  },
});
